// extracted by mini-css-extract-plugin
export default {"BasketTile":"BasketTile_KRE6K","BasketTile__clickable":"BasketTile__clickable_jWgM6","BasketTile__customBg":"BasketTile__customBg_ToK97"};